import {
  Box,
  Button,
  TextField,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { supabase } from "../supabaseClient";
import { useState } from "react";
import { Link } from "react-router-dom";

const generateSlug = (text) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const AddHerbForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    image_url: "",
    healing_benefits: "",
    recipe: "",
    facts: "",
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const slug = generateSlug(formData.name);
    const { error } = await supabase
      .from("herbs")
      .insert([{ ...formData, slug }]);
    if (error) setError("Failed to add herb.");
    else {
      setSuccess(true);
      setFormData({
        name: "",
        image_url: "",
        healing_benefits: "",
        recipe: "",
        facts: "",
      });
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", mt: 5 }}>
      <Typography variant="h4" gutterBottom>
        Add New Herb
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Name"
          name="name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          fullWidth
          required
          sx={{ mb: 2 }}
        />
        <TextField
          label="Image URL"
          name="image_url"
          value={formData.image_url}
          onChange={(e) =>
            setFormData({ ...formData, image_url: e.target.value })
          }
          fullWidth
          required
          sx={{ mb: 2 }}
        />
        <TextField
          label="Healing Benefits"
          name="healing_benefits"
          value={formData.healing_benefits}
          onChange={(e) =>
            setFormData({ ...formData, healing_benefits: e.target.value })
          }
          fullWidth
          multiline
          rows={3}
          required
          sx={{ mb: 2 }}
        />
        <TextField
          label="Recipe"
          name="recipe"
          value={formData.recipe}
          onChange={(e) => setFormData({ ...formData, recipe: e.target.value })}
          fullWidth
          multiline
          rows={3}
          required
          sx={{ mb: 2 }}
        />
        <TextField
          label="Facts"
          name="facts"
          value={formData.facts}
          onChange={(e) => setFormData({ ...formData, facts: e.target.value })}
          fullWidth
          multiline
          rows={3}
          required
          sx={{ mb: 2 }}
        />

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Box>
            <Button
              component={Link}
              to="/admin/herbs"
              variant="outlined"
              color="primary"
              sx={{ mr: 1 }}
            >
              ← Back to Herb Dashboard
            </Button>
            <Button
              component={Link}
              to="/herbs"
              variant="outlined"
              color="info"
            >
              View Library
            </Button>
          </Box>
          <Button type="submit" variant="contained" color="success">
            Add Herb
          </Button>
        </Box>
      </form>

      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
      >
        <Alert severity="success">Herb added successfully!</Alert>
      </Snackbar>
      <Snackbar
        open={!!error}
        autoHideDuration={3000}
        onClose={() => setError("")}
      >
        <Alert severity="error">{error}</Alert>
      </Snackbar>
    </Box>
  );
};

export default AddHerbForm;
